/* @flow */

import "./LogoutLink.scss";

import React from "react";

import { BusinessAccountResponse } from "../../../../datatypes/businessaccounts/BusinessAccount";
import _ from "lodash";

import { getComponentByName } from "../../../LazyWrapper";
const IdamCompatibleLogoutLink = getComponentByName("cia_ui/IdamCompatibleLogoutLink");

type Props = {
    data: BusinessAccountResponse | undefined | null;
};

/**
 * Note that this must also work, if we don't have any BussinessAccountData!
 */
export function LogoutLink(props: Props) {
    if (props.data) {
        const text = _.get(props.data.labels, ["logout", "text"]);
        return <IdamCompatibleLogoutLink text={text} />;
    }

    return (
        <li role="presentation">
            <IdamCompatibleLogoutLink className="logout-popover-metro-x" i18nKey="EX_LOGOUT_IN_HEADER" />
        </li>
    );
}
